var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Message, Modal } from "semantic-ui-react";
import { useQuery } from "@tanstack/react-query";
import { useTRPC } from "@iscr/xAppLib/context/QueryProvider";
import { Date } from "@iscr/views/icosm/treatment/components/Date";
import { AsyncButton } from "@iscr/views/UIelems/AsyncButton";
import { useAsyncUpdate } from "@iscr/xAppLib/Hooks/useAsync";
import { useDisclosure } from "@iscr/xAppLib/Hooks/useDisclosure";
import { EmbeddedContent } from "@iscr/mims/components/EmbeddedContent";
import { useMimsRegistrationState } from "@iscr/mims/context/MimsRegistrationProvider";
export function EulaModal(props) {
    var _a, _b, _c, _d;
    const { type, onAccept } = props;
    const { isOpen, onClose, onOpen } = useDisclosure(Object.assign({}, ("value" in props && {
        isOpenProp: "value" in props ? props.value : undefined,
        onCloseCallback: props.onChange,
        onOpenCallback: props.onChange,
    })));
    const accept = useAsyncUpdate(() => __awaiter(this, void 0, void 0, function* () {
        yield (onAccept === null || onAccept === void 0 ? void 0 : onAccept(eula.data.revisionDate));
        onClose();
    }));
    const trpc = useTRPC();
    const options = type === "consumer" ? trpc.mims.eula.consumer.queryOptions : trpc.mims.eula.provider.queryOptions;
    const eula = useQuery(Object.assign({}, options(undefined, {
        enabled: isOpen,
    })));
    return (_jsxs(Modal, { open: isOpen, onClose: onClose, onOpen: onOpen, closeOnDimmerClick: !onAccept, closeOnDocumentClick: !onAccept, closeOnEscape: !onAccept, trigger: "trigger" in props && props.trigger, size: "large", children: [_jsxs(Modal.Content, { children: [eula.isPending ? (_jsx(_Fragment, { children: "Loading..." })) : (_jsxs(_Fragment, { children: [((_a = eula.data) === null || _a === void 0 ? void 0 : _a.revisionDate) && (_jsxs("span", { children: [_jsx("strong", { children: "Revision date" }), ": ", _jsx(Date, { value: eula.data.revisionDate })] })), _jsx(EmbeddedContent, { html: (_b = eula.data) === null || _b === void 0 ? void 0 : _b.eula, className: "w-full min-h-[70vh]" })] })), accept.error && _jsx(Message, { error: true, visible: true, content: (_d = (_c = accept.error) === null || _c === void 0 ? void 0 : _c.message) !== null && _d !== void 0 ? _d : "Something went wrong" })] }), _jsxs(Modal.Actions, { children: [_jsx(Button, { type: "button", secondary: true, disabled: accept.loading, onClick: onClose, children: "Dismiss" }), onAccept && (_jsx(AsyncButton, { type: "button", primary: true, onClick: () => accept.fn(), loading: eula.isPending, disabled: eula.isPending, children: "Accept" }))] })] }));
}
export function EulaModalTrigger({ children = "View EULA" }) {
    const { value, actions, can } = useMimsRegistrationState();
    if (!can("mims:eula:accept")) {
        return null;
    }
    if (!(value === null || value === void 0 ? void 0 : value.type)) {
        return null;
    }
    return (_jsx(EulaModal, { type: value.type, onAccept: actions.acceptEula, trigger: _jsx(Button, { type: "button", basic: true, children: children }) }));
}
